import React from 'react'

import StoriesHeader from 'app/domains/routes/Stories/StoriesHeader'
import StoriesList from 'app/domains/routes/Stories/StoriesList/'

import './styles.scss'
const bc = 'stories'

const Stories = () => (
  <div className={bc}>
    <StoriesHeader />
    <StoriesList />
  </div>
)

export default Stories
